import { configureStore } from "@reduxjs/toolkit";
import clickActionReducer from "./clickActionSlice";
import slidersReducer from "./sliderSlice";
import aboutReducer from "./aboutSlice";
import bourseReducer from "./bourseSlice";
import noticeReducer from "./noticeSlice";
import customerReducer from "./customerSlice";
import stockReducer from "./stocksSlice";
import shareholderReportsReducer from "./shareholderReportsSlice";
import boardStructuresReducer from "./boardStructuresSlice";
import sustainabilityReportsReducer from "./sustainabilityReportsSlice";
import downloadableReportsReducer from "./downloadableReportsSlice";
import newsReducer from "./newsSlice";
import contactReducer from "./contactSlice";

const store = configureStore({
  reducer: {
    clickAction: clickActionReducer,
    sliders: slidersReducer,
    about: aboutReducer,
    bourse: bourseReducer,
    notices: noticeReducer,
    customers: customerReducer,
    stocks:stockReducer,
    shareholderReports: shareholderReportsReducer,
    boardStructures: boardStructuresReducer,
    sustainabilityReports: sustainabilityReportsReducer,
    downloadableReports: downloadableReportsReducer,
    news: newsReducer,
    contact:contactReducer
  },
});

export default store;
